var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"p-connected-overlay"},on:{"enter":_vm.onEnter,"leave":_vm.onLeave}},[(_vm.popup ? _vm.visible : true)?_c('div',{ref:"container",class:_vm.containerClass},[_c('TieredMenuSub',{attrs:{"model":_vm.model,"root":true,"popup":_vm.popup},on:{"leaf-click":_vm.onLeafClick}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }